import * as type from "./type";
import produce from "immer";

const initialState = {
  bannerList: null,
};

const BannerReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case type.GET_BANNER_LIST_REQUEST:
        draft.bannerList = null;
        break;
      case type.GET_BANNER_LIST_SUCCESS:
        draft.bannerList = action.payload;
        break;
      default:
        break;
    }
  });
};

export default BannerReducer;
